<template>
    <div class="sub-claims">
        <div ref="supporting" class="supporting-claims">
            <transition-group name="list">
                <LargeClaim v-for="supportingClaim in supportingClaims"
                    :key="supportingClaim.id"
                    :ref="'supportingClaim' + supportingClaim.id"
                    :claim="supportingClaim"
                    @claimUpdated="claimUpdated"
                    @openClaim="openClaim"
                ></LargeClaim>
            </transition-group>
        </div>
        <div class="supporting-weighting">
            <svg ref="supportingSvg" xmlns="http://www.w3.org/2000/svg">
                <transition-group name="list" tag="g">
                    <path v-for="supportingId in supporting" 
                        :key="supportingId"
                        :ref="'supportingPath' + supportingId"
                        :stroke-opacity="getPathOpacity('supporting', supportingId)"
                    ></path>
                </transition-group>
                <!-- <text v-for="(percent, id) in percents.displaySupporting || []"
                    :key="id + ':' + percent"
                    :ref="'supportingLabel' + id"
                >
                    {{percent | percent}}
                </text> -->
                <transition-group name="list" tag="g">
                    <foreignObject
                        v-for="(percent, id) in percents.displaySupporting || []"
                        :key="id + ':' + percent"
                        :ref="'supportingLabel' + id"
                        class="percent-editor"
                    >
                        <PercentEditor :value="percent" @edited="percentEdited(id, $event)"></PercentEditor>
                    </foreignObject>
                </transition-group>

                <path 
                    ref="supportingPathZeroState"
                    v-if="!supporting.length"
                ></path>
                <text ref="supportingPercentTotal">{{percentTotals.supporting | percent}}</text>
            </svg>
        </div>
        <div class="opposing-weighting">
            <svg ref="opposingSvg" xmlns="http://www.w3.org/2000/svg">
                <transition-group name="list" tag="g">
                    <path v-for="opposingClaimId in opposing"
                        :key="opposingClaimId"
                        :ref="'opposingPath' + opposingClaimId"
                        :stroke-opacity="getPathOpacity('opposing', opposingClaimId)"
                    ></path>
                </transition-group>
                <!-- <text v-for="(percent, id) in percents.displayOpposing || []"
                    :key="id + ':' + percent"
                    :ref="'opposingLabel' + id"
                >
                    {{percent | percent}}
                </text> -->
                <transition-group name="list" tag="g">
                    <foreignObject 
                        v-for="(percent, id) in percents.displayOpposing || []"
                        :key="id + ':' + percent"
                        :ref="'opposingLabel' + id"
                        class="percent-editor"
                    >
                        <PercentEditor :value="percent" @edited="percentEdited(id, $event)"></PercentEditor>
                    </foreignObject>
                </transition-group>

                <path 
                    ref="opposingPathZeroState"
                    v-if="!opposing.length"
                ></path>
                <text ref="opposingPercentTotal">{{percentTotals.opposing | percent}}</text>
            </svg>
        </div>
        <div ref="opposing" class="opposing-claims">
            <transition-group name="list">
                <LargeClaim v-for="opposingClaim in opposingClaims"
                    :key="opposingClaim.id"
                    :ref="'opposingClaim' + opposingClaim.id"
                    :claim="opposingClaim"
                    @claimUpdated="claimUpdated"
                    @openClaim="openClaim"
                ></LargeClaim>
            </transition-group>
        </div>
    </div>
</template>

<script>
    import LargeClaim from '../components/LargeClaim.vue';
    import PercentEditor from '../components/PercentEditor.vue';
    import { percentFilter } from '../utility/filters';
    import { getStatusBackgroundColorClass, getStatusIconClass, getStatusTitle } from '../utility/StatusGenerator';
    import { $space4, $space32, $space64 } from '../utility/Tokens';

    export default {
        props: {
            claims: Array,
            percentTotals: Object,
            percents: Object,
            supporting: Array,
            opposing: Array
        },
        mounted() {
            this.mtnObserver = new MutationObserver((MutationObserver, observer) => {
                this.drawSvg();
            });
            this.mtnObserver.observe($('.sub-claims')[0], {
                attributes: false,
                childList: true,
                subtree: true 
            });
        },
        beforeDestroy() {
            this.mtnObserver.disconnect();
        },
        // updated() {
        //     this.$nextTick(function () {
        //         this.drawSvg();
        //     });
        // },
        methods: {
            getPathOpacity: function(type, claimId) {
                let percent;
                if (type === 'supporting') {
                    percent = this.percents.displaySupporting[claimId];
                } else {
                    percent = this.percents.displayOpposing[claimId];
                }

                return Math.max(0.1, percent);
            },
            getStatusBackgroundColorClass: getStatusBackgroundColorClass,
            getStatusIconClass: getStatusIconClass,
            getStatusTitle: getStatusTitle,
            getClaims: function(ids, map) {
                return ids.map(id => map[id]);
            },
            drawPaths: function(svgWidth, strokeWidth) {
                if (!this.supporting.length) {
                    this.$refs.supportingPathZeroState.setAttribute('d', `M${svgWidth - strokeWidth / 2} 0 L${svgWidth - strokeWidth / 2} 32`);
                }
                for (let supportingId of this.supporting) {
                    this.drawSupportingPath(
                        svgWidth,
                        strokeWidth,
                        this.$refs['supportingClaim' + supportingId][0].$el,
                        this.$refs['supportingPath' + supportingId][0],
                        this.$refs['supportingLabel' + supportingId][0]
                    );
                }

                if (!this.opposing.length) {
                    this.$refs.opposingPathZeroState.setAttribute('d', `M${strokeWidth / 2} 0 L${strokeWidth / 2} 32`);
                }
                for (let opposingId of this.opposing) {
                    this.drawOpposingPath(
                        svgWidth,
                        strokeWidth,
                        this.$refs['opposingClaim' + opposingId][0].$el,
                        this.$refs['opposingPath' + opposingId][0],
                        this.$refs['opposingLabel' + opposingId][0]
                    );
                }
            },
            drawSupportingPath(svgWidth, strokeWidth, claimElement, pathElement, labelElement) {
                const y = claimElement.offsetTop + ($(claimElement).outerHeight() / 2);

                pathElement.setAttribute('d', 
                    `M${svgWidth - strokeWidth / 2} 0 C${svgWidth - strokeWidth / 2} ${y - strokeWidth / 2}, ${svgWidth - strokeWidth / 2} ${y - strokeWidth / 2}, 0 ${y}`
                );

                const percentEditorWidth = $space64;
                const percentEditorHeight = $space32;
                labelElement.setAttribute('x', $space32 - (percentEditorWidth / 2));
                labelElement.setAttribute('y', y - (percentEditorHeight / 2) - $space4);
            },
            drawOpposingPath(svgWidth, strokeWidth, claimElement, pathElement, labelElement) {
                const y = claimElement.offsetTop + ($(claimElement).outerHeight() / 2);

                pathElement.setAttribute('d', 
                    `M${strokeWidth / 2} 0 C${strokeWidth / 2} ${y - strokeWidth / 2}, ${strokeWidth / 2} ${y - strokeWidth / 2}, ${svgWidth} ${y}`
                );

                const percentEditorWidth = $space64;
                const percentEditorHeight = $space32;
                labelElement.setAttribute('x', svgWidth - $space32 - (percentEditorWidth / 2));
                labelElement.setAttribute('y', y - (percentEditorHeight / 2) - $space4);
            },
            drawSvg: function() {
                const svgWidth = 120;
                const strokeWidth = 60;

                const supportingHeight = $(this.$refs.supporting).outerHeight(true);
                const opposingHeight = $(this.$refs.opposing).outerHeight(true);

                //TODO: This sometimes doesn't exist due to v-if. Server is fucked up. Fix later
                this.$refs.supportingSvg.setAttribute('viewBox', `0 0 ${svgWidth} ${supportingHeight}`);
                this.$refs.opposingSvg.setAttribute('viewBox', `0 0 ${svgWidth} ${opposingHeight}`);

                this.drawPaths(svgWidth, strokeWidth);

                this.$refs.supportingPercentTotal.setAttribute('x', svgWidth - strokeWidth / 2);
                this.$refs.supportingPercentTotal.setAttribute('y', $space32);
                this.$refs.opposingPercentTotal.setAttribute('x', strokeWidth / 2);
                this.$refs.opposingPercentTotal.setAttribute('y', $space32);
            },
            claimUpdated: function(e) {
                this.$emit('claimUpdated', e);
            },
            openClaim: function(e) {
                this.$emit('openClaim', e);
            },
            percentEdited: function(id, e) {
                this.$emit('percentEdited', {
                    id: id,
                    percent: e
                });
            }
        },
        filters: {
            percent: percentFilter
        },
        data() {
            return {
                mtnObserver: undefined
            };
        },
        computed: {
            claimsMap() {
                return this.claims.reduce((claimMap, current) => {
                    claimMap[current.id] = current;
                    return claimMap;
                }, {});
            },
            supportingClaims() {
                return this.getClaims(this.supporting, this.claimsMap);
            },
            opposingClaims() {
                return this.getClaims(this.opposing, this.claimsMap);
            }
        },
        components: {
            LargeClaim,
            PercentEditor
        }
    }
</script>

<style scoped lang="scss">
    .sub-claims {
        position: relative;
        display: flex;
        flex-direction: row;

        .list-enter-active, .list-leave-active, .list-move {
            transition: all .5s;
        }
        .list-enter, .list-leave-to {
            opacity: 0;
        }

        .supporting-claims, .opposing-claims {
            width: 50%;
            margin-top: $space-32;

            > * {
                margin-bottom: $space-32;
            }
        }
        .supporting-weighting, .opposing-weighting {
            flex-shrink: 0;
            width: 120px;

            svg {
                width: 100%;
                height: 100%;
                fill: none;

                path {
                    stroke-width: 60px;
                    stroke-linecap: round;
                }

                text {
                    fill: $black;
                    text-anchor: middle;
                }

                .percent-editor {
                    width: $space-64;
                    height: $space-32;
                }
            }
        }

        .supporting-weighting {
            path {
                stroke: $trueColor;
            }
        }

        .opposing-weighting {
            path {
                stroke: $falseColor;
            }
        }
    }
</style>